import { PpfRouteData } from "@ppf/shared/data";

const baseRoute = "grid-services";

export const GRID_SERVICES_ROUTE_DATA: PpfRouteData<
	| "base"
	| "address"
	| "contact"
	| "solarSystem"
	| "results"
	| "financing"
	| "ineligible"
	| "enfin"
	| "inverter"
	| "battery"
	| "batteryInfo"
	| "installer"
	| "projectStage"
> = {
	base: {
		route: baseRoute,
		fullRoute: `/${baseRoute}`,
	},
	address: {
		route: "address",
		fullRoute: `/${baseRoute}/address`,
	},
	contact: {
		route: "contact",
		fullRoute: `/${baseRoute}/contact`,
	},
	financing: {
		route: "financing",
		fullRoute: `/${baseRoute}/financing`,
	},
	solarSystem: {
		route: "solar-system",
		fullRoute: `/${baseRoute}/solar-system`,
	},
	ineligible: {
		route: "ineligible",
		fullRoute: `/${baseRoute}/ineligible`,
	},
	enfin: {
		route: "enfin",
		fullRoute: `/${baseRoute}/enfin`,
	},
	inverter: {
		route: "inverter",
		fullRoute: `/${baseRoute}/inverter`,
	},
	battery: {
		route: "battery",
		fullRoute: `/${baseRoute}/battery`,
	},
	batteryInfo: {
		route: "battery-info",
		fullRoute: `/${baseRoute}/battery-info`,
	},
	installer: {
		route: "installer",
		fullRoute: `/${baseRoute}/installer`,
	},
	projectStage: {
		route: "project-stage",
		fullRoute: `/${baseRoute}/project-stage`,
	},
	results: {
		route: "results",
		fullRoute: `/${baseRoute}/results`,
	},
};
